import { sendDelete, sendGet, sendPost, sendPut } from "api/restUtil";
import {useEffect, useMemo, useState} from 'react';
import SearchList from 'components/SearchList';
import ReactDataTableDisplay from 'components/DataTable/ReactDataTableDisplay';
import { getTodayStr } from "js/common";
import BasicButton from "components/button/BasicButton";
import OrderDetailModal from "./OrderDetailModal";

// 조건형 주문 목록 (api로 직접 조회)
function OrderListByCond() {

	//데이터 목록
	const [ dataList, setDataList ] = useState([]);
	//초기 검색 조건 데이터
	const [ initialCondition, setInitialCondition] = useState({});
	//검색 데이터
	const [ condition, setCondition] = useState({});
	// 페이지 정보
	const [ pageInfo, setPageInfo ] = useState({});

	// 주문 상세 팝업
	const [isOpenOrderDetailPop, setIsOpenOrderDetailPop] = useState(false);
	// 주문 상세 팝업 표시할 주문 번호
	const [selectedOrderId, setSelectedOrderId] = useState(null);

	//검색 조건
	const conditionList = [
		// {
		// 	title : "검색 기간",
		// 	col : ["from", "to"],
		// 	type : "dayPickerInputTerm",
		// 	required: true,
		// },
		{
			title : "검색 일자",
			col : "searchDt",
			type : "datePicker",
			required: true,
		},
		{
			title: "검색 구분",
			col: "rangeType",
			type: "commonCodeSelect",
			grpCd: "RANGE_TYPE",
			addDefault: false,
		}
	];
	
	
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "주문번호", col : "orderId", cellWidth: "100"},
		{ header : "상품주문번호", col : "productOrderId", cellWidth : "100" },
		{ header : "상품명", col : "productName", cellWidth : "100" },
		{ header : "상품주문상태", col : "productOrderStatus", cellWidth : "100" },
		{ header : "발주상태", col : "placeOrderStatus", cellWidth : "100" },
		{ header : "클레임상태", col : "claimStatus", cellWidth : "100" },
		{ header : "클레임구분", col : "claimType", cellWidth : "100" },
		{ header : "주문상세", col : "orderId", type: "modButton", cellWidth : "100", label: "보기", onClick: (d) => setSelectedOrderId(d.orderId) },
	], []);

	useEffect(() =>{
		const initData = async () => {
			
			//초기 검색 조건
			const today = getTodayStr();
			// 원래는 검색구분도 넣어야 하는데... 이거 미선택이면 기본으로  결제일시를 기준으로 하기 때문에...
			// 처음에는 세팅이 안되어 있겠지만 결제일시로 검색됨. 이후에는 검색조건에 결제일시가 설정 되어 있으므로 뭐...
			// const newCond = {from: today, to: today};
			const newCond = {searchDt: today};
			setInitialCondition(newCond);
			searchList(newCond);
		};

		initData();

	}, []);

	// 데이터 형태변환
	const objDataToFlat = (origList) => {
		// obj 형태의 response데이터를 테이블에 표시하기 위해 필요 정보를 flat하게 변경
		const list = origList.map(d => {
			return {
				productOrderId : d.productOrderId,
				orderId : d.content.order.orderId,
				orderDate : d.content.order.orderDate,
				ordererName : d.content.order.ordererName,
				ordererTel : d.content.order.ordererTel,
				paymentDate : d.content.order.paymentDate,
				payLaterPaymentAmount : d.content.order.payLaterPaymentAmount,	// 후불 결제 금액
				claimStatus : d.content.productOrder.claimStatus,	// 클레임 상태
				claimType : d.content.productOrder.claimType,	// 클레임 구분
				decisionDate : d.content.productOrder.decisionDate,	// 구매확정일
				expectedDeliveryMethod : d.content.productOrder.expectedDeliveryMethod,	// 배송 방법 코드
				originalProductId : d.content.productOrder.originalProductId,	// 원상품번호
				productName : d.content.productOrder.productName,	// 상품명
				productOption : d.content.productOrder.productOption,	// 상품옵션
				productOrderStatus : d.content.productOrder.productOrderStatus,	// 상품주문상태
				placeOrderStatus : d.content.productOrder.placeOrderStatus,	// 상품발주상태

				origData: d,
			};
		});


		return list;
	}


	//목록 조회
	const searchList = async (cond = {}) => {

		const tmpCond = {...cond};
		tmpCond.from = tmpCond.searchDt + " 00:00";
		tmpCond.to = tmpCond.searchDt + " 23:59";
		// tmpCond.from = tmpCond.from + " 00:00";
		// tmpCond.to = tmpCond.to + " 23:59";
		delete tmpCond.searchDt;

		let result = await sendGet("/api/order/condPrdOrdrDtlList", tmpCond);
		if(result.respCode === "SUCCESS"){

			setCondition(cond);

			const dataList = result.data.data.contents;
			const flatList = objDataToFlat(dataList);
			setDataList(flatList);
			setPageInfo(result.data.data.pagination);
			// setPagingInfo({hasNext: page.hasNext, pageNo: page.page, searchFnc : searchList, searchCond : cond});
		}
	}

	const getNextData = () => {

		const tmpCond = {...condition};
		tmpCond.page = pageInfo.page + 1;

		searchList(tmpCond);
	}

	const getPrevData = () => {
		if(pageInfo.page <= 1) return;

		const tmpCond = {...condition};
		tmpCond.page = pageInfo.page + 1;

		searchList(tmpCond);
	}

	useEffect(() => {
		// selectedOrderId가 있으면 팝업 표시. 없으면 팝업 닫기.
		setIsOpenOrderDetailPop(selectedOrderId != null);
	}, [selectedOrderId]);


	return (
		<div className="ant-tabs-tabpane">
			<SearchList conditionList={conditionList} onSearch={searchList} initialData={initialCondition} />

			<div className="table-buttons mg-t-10 mg-b-10">
				<span>현재페이지 : {pageInfo.page}</span>
				{pageInfo.page > 1 && (
					<BasicButton
						label="이전데이터"
						className="btn-add"
						onClick={() => getPrevData()}
					/>
				)}
				{pageInfo.hasNextData && (
					<BasicButton
						label="다음데이터"
						className="btn-add"
						onClick={() => getNextData()}
					/>
				)}
			</div>

			<ReactDataTableDisplay
				columns={columns}
				customDatas={dataList}
				hideCheckBox={true}
				percentageWidth={true}
				isPageNation={false}
				// rowClick={"checkbox"}
			/>

			
			<OrderDetailModal
				isOpen={isOpenOrderDetailPop}
				initData={{orderId: selectedOrderId}}
				onClose={()=> {setSelectedOrderId(null);}}
				title={`주문상세 [${selectedOrderId}]`}
			/>

		</div>
	);
}

export default OrderListByCond;